'use client'
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC } from 'react'

import { PhnxGroupStylePanel } from './GroupStylePanel'
import { GroupStylePanelProps } from './GroupStylePanel'

interface GroupStylePanelBlokProps {
  blok: { variant: GroupStylePanelProps['variant']; content: SbBlokData[] } & SbBlokData
}

const Groupstylepanel: FC<GroupStylePanelBlokProps> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <PhnxGroupStylePanel
        variant={blok.variant.toLowerCase() as GroupStylePanelProps['variant']}
        content={
          blok.content &&
          blok.content.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
      />
    </div>
  )
}

export default Groupstylepanel
